export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-06-13 at 22.28.55.19d9c386.jpeg";